var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({class:['btn-trigger', _vm.expanded && 'is-open'],attrs:{"tabindex":"0"}},_vm.$listeners),[_c('i',{staticClass:"icon icon-arrow_down_filled"})])
}
var staticRenderFns = []

export { render, staticRenderFns }